import { pageMeta, workDate } from '../../pages/pageMetadata';
import type { EditorBlock, EditorPage } from '../editor.types';

export type CoverPicture = Pick<EditorBlock, 'asset_id' | 'content'>;
export function workCover(page: EditorPage, fallback: CoverPicture | null): CoverPicture | null {
  const cover = pageMeta(page).cover;
  if (cover && typeof cover === 'object' && !Array.isArray(cover)) {
    if (typeof cover.assetId === 'string') return { asset_id: cover.assetId, content: {} };
    if (typeof cover.sample === 'string') return { asset_id: null, content: { sample: cover.sample } };
  }
  return fallback;
}
export function workCardText(page: EditorPage) {
  const meta = pageMeta(page);
  return {
    details: [meta.showCategory !== false && typeof meta.category === 'string' ? meta.category : '', meta.showDate !== false ? workDate(page).slice(0, 4) : ''].filter(Boolean).join(' · '),
    description: typeof meta.cardDescription === 'string' ? meta.cardDescription : page.description,
  };
}
